"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthErrorCode = void 0;
/**
 * Error codes surfaced on `ExtendedGraphQLErrors.extensions.errors[*].code` by
 * auth-related mutations and guards. Defined in `@common/neo.tax` so server
 * throws and frontend branches reference the exact same strings — prevents
 * typo drift between ends.
 *
 * Add a new member here whenever the backend starts throwing a new coded auth
 * error; referenced places will break at compile time and point you at every
 * caller that needs to handle it.
 */
var AuthErrorCode;
(function (AuthErrorCode) {
    AuthErrorCode["EMAIL_NOT_VERIFIED"] = "EMAIL_NOT_VERIFIED";
    /** The organization admits only its enterprise SSO provider, and this session signed in some other way. */
    AuthErrorCode["ENTERPRISE_SSO_REQUIRED"] = "ENTERPRISE_SSO_REQUIRED";
    AuthErrorCode["EMAIL_VERIFICATION_TOO_FREQUENT"] = "EMAIL_VERIFICATION_TOO_FREQUENT";
    AuthErrorCode["EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS_TRY_LATER"] = "EMAIL_VERIFICATION_TOO_MANY_ATTEMPTS_TRY_LATER";
    AuthErrorCode["INVALID_CONTINUE_URL"] = "INVALID_CONTINUE_URL";
})(AuthErrorCode || (exports.AuthErrorCode = AuthErrorCode = {}));
